// extracted by mini-css-extract-plugin
module.exports = {"desk":"Grid-module_desk_3nz4W","table":"Grid-module_table_6Stwc","actions":"Grid-module_actions_2tH8s","dropdown":"Grid-module_dropdown_2JJrQ","icon":"Grid-module_icon_2i7AP"};